import React from 'react';

// ##### CUSTOM ACCOUNTS CROSSCHECK COMPONENT
const CustomAccountsCrosscheck = ({ 
  accounts, 
  flowVariation, 
  handleFlowVariationChange, 
  addingHistory,
  calculateBalanceDifference,
  formatDate 
}) => {
  const balanceDiff = calculateBalanceDifference();
  
  if (!balanceDiff) {
    return (
      <div className="p-2 bg-gray-50 rounded-lg border border-gray-200">
        <div className="text-xs text-gray-600 text-center">
          Adicione pelo menos 2 datas para visualizar a diferença de saldo
        </div>
      </div>
    );
  }

  return (
    <div className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden">
      <table className="w-full table-fixed">
        <thead className="bg-gray-50">
          <tr>
            <th className="px-2 py-1 text-left text-xs font-semibold text-gray-600 tracking-wider border-r border-gray-200 w-24">
              Date
            </th>
            {accounts.map((account) => (
              <th key={account.id} className="px-1 py-1 text-center text-xs font-semibold text-gray-600 tracking-wider border-r border-gray-200 bg-gray-100" style={{ width: `calc((100% - 96px) / ${accounts.length})` }}>
                <div className="flex flex-col items-center gap-0.5">
                  <div className="flex-shrink-0 h-4 w-4 bg-blue-100 rounded-full flex items-center justify-center">
                    <span className="text-xs font-medium text-blue-600">
                      {account.account_name.charAt(0).toUpperCase()}
                    </span>
                  </div>
                  <span className="text-xs font-medium truncate">{account.account_name}</span>
                </div>
              </th>
            ))}
          </tr>
        </thead>
        <tbody className="bg-white divide-y divide-gray-200">
          {/* Initial Row */}
          <tr className="hover:bg-gray-50">
            <td className="px-2 py-1 text-xs font-medium text-gray-700 border-r border-gray-200 w-24">
              Initial ({formatDate(balanceDiff.previousDate)})
            </td>
            {accounts.map((account) => {
              const calc = balanceDiff.calculations.find(c => c.accountName === account.account_name);
              return (
                <td key={account.id} className="text-center text-xs text-gray-600 border-r border-gray-200" style={{ width: `calc((100% - 96px) / ${accounts.length})` }}>
                  {calc.initialValue.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                </td>
              );
            })}
          </tr>
          
          {/* Flow Variation Row */}
          <tr className="hover:bg-gray-50 bg-blue-50">
            <td className="px-2 py-1 text-xs font-medium text-blue-700 border-r border-gray-200 w-24">
              Flow Variation
            </td>
            {accounts.map((account) => {
              return (
                <td key={account.id} className="text-center border-r border-gray-200" style={{ width: `calc((100% - 96px) / ${accounts.length})` }}>
                  <input
                    type="text"
                    value={flowVariation[account.id] || ''}
                    onChange={(e) => handleFlowVariationChange(account.id, e.target.value)}
                    placeholder="0,00"
                    className="w-full h-full bg-transparent border-none outline-none text-center text-xs font-medium focus:bg-blue-100"
                    disabled={addingHistory}
                  />
                </td>
              );
            })}
          </tr>
          
          {/* End Calculated Row */}
          <tr className="hover:bg-gray-50 bg-green-50">
            <td className="px-2 py-1 text-xs font-medium text-green-700 border-r border-gray-200 w-24">
              End Calculated
            </td>
            {accounts.map((account) => {
              const calc = balanceDiff.calculations.find(c => c.accountName === account.account_name);
              return (
                <td key={account.id} className="text-center text-xs text-green-600 border-r border-gray-200" style={{ width: `calc((100% - 96px) / ${accounts.length})` }}>
                  {calc.endCalculated.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                </td>
              );
            })}
          </tr>
          
          {/* End Reference Row */}
          <tr className="hover:bg-gray-50 bg-gray-50">
            <td className="px-2 py-1 text-xs font-medium text-gray-700 border-r border-gray-200 w-24">
              End Reference ({formatDate(balanceDiff.latestDate)})
            </td>
            {accounts.map((account) => {
              const calc = balanceDiff.calculations.find(c => c.accountName === account.account_name);
              return (
                <td key={account.id} className="text-center text-xs text-gray-600 border-r border-gray-200" style={{ width: `calc((100% - 96px) / ${accounts.length})` }}>
                  {calc.endReference.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                </td>
              );
            })}
          </tr>
          
          {/* Difference Row */}
          <tr className="bg-orange-50 hover:bg-orange-100 border-t-2 border-orange-200">
            <td className="px-2 py-1 text-xs font-semibold text-orange-800 border-r border-gray-200 w-24">
              Difference
            </td>
            {accounts.map((account) => {
              const calc = balanceDiff.calculations.find(c => c.accountName === account.account_name);
              
              return (
                <td key={account.id} className="text-center border-r border-gray-200" style={{ width: `calc((100% - 96px) / ${accounts.length})` }}>
                  {calc.difference !== 0 ? (
                    <span className={`text-xs font-semibold px-2 py-1 rounded ${
                      calc.difference > 0 
                        ? 'bg-green-100 text-green-800' 
                        : 'bg-red-100 text-red-800'
                    }`}>
                      {calc.difference > 0 ? '+' : ''}{calc.difference.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                    </span>
                  ) : (
                    <span className="text-xs text-gray-400">0,00</span>
                  )}
                </td>
              );
            })}
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default CustomAccountsCrosscheck;
